<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'CurrentShift.title' | translateWF: 'Current Shift' }}</h1>
      </div>
    </div>

    <!-- Current Shift Section -->
    <p-panel [header]="'CurrentShift.current_shift_info' | translateWF: 'Current Shift Information'">
      <ng-template pTemplate="icons">
        @if (isShiftsAdmin) {
          <p-button
            [label]="'CurrentShift.edit' | translateWF: 'Edit'"
            icon="pi pi-pencil"
            (onClick)="openEditModal()"
            [outlined]="true"
            [disabled]="!currentShift || isLoading() > 0"
          />
        }
      </ng-template>

      <p-card>
        <div class="grid-auto-4">
          <div class="form-box">
            <label>{{ 'CurrentShift.shift' | translateWF: 'Shift' }}</label>
            <p class="shift-value">{{ currentShift ? getShiftLabel(currentShift.shift) : '-' }}</p>
          </div>
        </div>
      </p-card>

      <ng-template pTemplate="footer">
        <p class="report-description">
          {{
            'CurrentShift.current_shift_description'
              | translateWF
                : 'View and manage the current active shift
          details'
          }}
        </p>
      </ng-template>
    </p-panel>
  </div>
</main>
